module.exports = __webpack_public_path__ + "img/banner.4fd00df4.png";